<template>
  <div
    style="
      width: 10.5in;
      height: 6.5in;
      background-color: black;
      overflow: hidden;
    "
  >
    <v-container
      class="noprint"
      style="background-color: wheat; width: 100%; height: 2in"
    >
      <!-- name: "Retif Cooper",
        attack_name: "Long Sword",
        stat_base: 14,
        bonus: 4,
        WC: 6,
        wc_bonus
        damavg: 12,
        dammax: 36, -->
      <v-row>
        <v-col cols="3">
          <v-text-field
            class="ml-2"
            label="Name"
            v-model="atkmtx.name"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            class="ml-2"
            label="Attck Name"
            v-model="atkmtx.attack_name"
          ></v-text-field>
        </v-col>
        <v-col cols="1">
          <v-text-field
            class="ml-2"
            label="Stat Base"
            v-model="atkmtx.stat_base"
          ></v-text-field>
        </v-col>
        <v-col cols="1">
          <v-text-field
            class="ml-2"
            label="Bonus"
            v-model="atkmtx.bonus"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="1">
          <v-text-field
            class="ml-2"
            label="WC"
            v-model="atkmtx.WC"
          ></v-text-field>
        </v-col>
        <v-col cols="1">
          <v-text-field
            class="ml-2"
            label="WC BNS"
            v-model="atkmtx.wc_bonus"
          ></v-text-field>
        </v-col>
        <v-col cols="1">
          <v-text-field
            class="ml-2"
            label="Dam Max"
            v-model="atkmtx.dammax"
          ></v-text-field>
        </v-col>
        <v-col cols="1">
          <v-text-field
            class="ml-2"
            label="Dam Avg"
            v-model="atkmtx.damavg"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-btn color="primary" elevation="2" @click="captrue">Capture</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      style="height: 8in; width: 10.5in; overflow: hidden"
      class="d-flex flex-column justify-start whitewhite black--text"
      id="main-matrix"
    >
      <!--//@*/*
    //    *BUS Dice Cars  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

      <!-- character demo -->
      <div
        class="line2 d-flex flex-row justify-space-between white black--text mt-4"
      >
        <label class="fxtitle ml-1">BETA FX Attack Matrix</label>
        <div class="d-flex flex-row justify-start white black--text pt-3 mr-3">
          <v-spacer></v-spacer>
          <div
            class="label-pair d-flex flex-row justify-start white black--text"
          >
            <label class="biglbl" style="font-size: 1.3rem"
              >Character Name:</label
            >
            <article class="nameitem ml-2">
              {{ atkmtx.name }}
            </article>
          </div>
          <div
            class="label-pair ml-6 d-flex flex-row justify-start white black--text"
          >
            <label class="biglbl" style="font-size: 1.3rem">Attack Name:</label>
            <article class="nameitem ml-2">
              {{ atkmtx.attack_name }}
            </article>
          </div>
        </div>
      </div>
      <div class="line2 d-flex flex-row justify-start white black--text">
        <div
          class="label-pair ml-6 d-flex flex-row justify-start white black--text"
        >
          <label class="biglbl">Stat/Base: </label>
          <article class="nameitem ml-2">
            {{ atkmtx.stat_base }}
          </article>
        </div>
        <div
          class="label-pair ml-4 d-flex flex-row justify-start white black--text"
        >
          <label class="biglbl">Bonus:</label>
          <article class="nameitem ml-2">
            {{ atkmtx.bonus }}
          </article>
        </div>
        <div
          class="label-pair ml-4 d-flex flex-row justify-start white black--text"
        >
          <label class="biglbl">WC:</label>
          <article class="nameitem ml-2">
            {{ atkmtx.WC }}
          </article>
        </div>
        <div
          class="label-pair ml-4 d-flex flex-row justify-start white black--text"
        >
          <label class="biglbl">Dam Avg:</label>
          <article class="nameitem ml-2">
            {{ atkmtx.damavg }}
          </article>
        </div>
        <div
          class="label-pair ml-4 d-flex flex-row justify-start white black--text"
        >
          <label class="biglbl">Dam Max:</label>
          <article class="nameitem ml-2">
            {{ atkmtx.dammax }}
          </article>
        </div>
        <v-spacer></v-spacer>
        <small class="code-size mr-2">{{ this.thiscode }}</small>
      </div>
      <!-- TO HIT -->
      <div class="white" style="width: 100%">
        <hr class="white" style="width: 98%; margin: 0 auto" />
      </div>
      <div id="tohit" class="white">
        <div class="d-flex flex-row justify-space-between">
          <label class="simple_lbl ml-1">To Hit</label>
          <v-spacer></v-spacer>
        </div>

        <div class="line3 line3 d-flex flex-row justify-start">
          <div
            class="tiny_block"
            :class="{
              tiny_block_invert: (index1 + 1) % 5 == 0 ? true : false,
            }"
            v-for="(totalatk, index1) in totalatk"
            :key="index1"
          ></div>
        </div>
        <div id="atk_cut1" class="line4 d-flex flex-row justify-start">
          <div
            class="tiny_num"
            :class="{
              tiny_num_invert: (index2 + 1) % 5 == 0 ? true : false,
            }"
            v-for="(number, index2) in numbers"
            :key="index2"
          >
            |{{ number }}
          </div>
        </div>
      </div>
      <div id="wcac" class="white mt-4">
        <div class="d-flex flex-row justify-space-between">
          <label class="simple_lbl mt-2 ml-1">WC vs AC</label>
          <v-spacer></v-spacer>
          <small class="code-size mr-2">{{ this.thiscode }}</small>
        </div>
        <div class="line5 line5 d-flex flex-row justify-start">
          <div
            class="tiny_block2"
            :class="{
              tiny_block2_invert: (index4 + 1) % 5 == 0 ? true : false,
            }"
            v-for="(wc_count, index4) in wc_count"
            :key="index4"
          ></div>
        </div>
        <div class="line4 d-flex flex-row justify-start">
          <div
            class="tiny_num"
            :class="{
              tiny_num_invert: (index2 + 1) % 5 == 0 ? true : false,
            }"
            v-for="(number, index2) in numbers"
            :key="index2"
          >
            |{{ number }}
          </div>
        </div>
      </div>
      <div id="damage" class="white mt-4" style="height: 1in">
        <div class="d-flex flex-row justify-space-between">
          <label class="simple_lbl mt-2 ml-1">Damage</label>
          <v-spacer></v-spacer>
          <small class="code-size mr-2">{{ this.thiscode }}</small>
        </div>

        <div class="damage_line d-flex flex-row justify-start">
          <div class="vert_pair d-flex flex-column justify-start align-center">
            <label>[3]</label>
            <Article>{{ damage_array[0] }}</Article>
          </div>
          <div class="vert_pair d-flex flex-column justify-start align-center">
            <label>[4-5]</label>
            <Article>{{ damage_array[1] }}</Article>
          </div>
          <div class="vert_pair d-flex flex-column justify-start align-center">
            <label>[6-8]</label>
            <Article>{{ damage_array[2] }}</Article>
          </div>
          <div class="vert_pair d-flex flex-column justify-start align-center">
            <label>[9-12]</label>
            <Article>{{ damage_array[3] }}</Article>
          </div>
          <div class="vert_pair d-flex flex-column justify-start align-center">
            <label>[13-15]</label>
            <Article>{{ damage_array[4] }}</Article>
          </div>
          <div class="vert_pair d-flex flex-column justify-start align-center">
            <label>[16-17]</label>
            <Article>{{ damage_array[5] }}</Article>
          </div>
          <div class="vert_pair d-flex flex-column justify-start align-center">
            <label>[18]</label>
            <Article>{{ damage_array[6] }}</Article>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
@font-face {
  font-family: SuiCoward;
  src: url("Sui Coward.otf") format("opentype");
}
.vert_pair label {
  margin-left: 4px;
  margin-right: 4px;
}
.vert_pair article {
  margin-left: 4px;
  font-weight: 800;
}
.simple_lbl {
  font-family: SuiCoward;
  font-size: 1.5rem;
}
.cut_defmatrix_info {
  height: 125px;
  width: 100%;
  background-color: black;
}
.cut_tohit_defense {
  width: 966px;
  height: 0.46in;
  background-color: black;
}
.clrtest {
  color: #e9ebf5;
}
.biglbl {
  font-weight: 800;
}
.fxtitle {
  font-family: SuiCoward;
  font-size: 2rem;
}
.label-pair label {
  font-family: SuiCoward;
  font-size: 1.1rem;
}
.label-pair article {
  color: darkblue;
  text-decoration: underline;
  font-family: SuiCoward;
  font-size: 1.5rem;
  position: relative;
  top: -4px;
}
.tiny_block {
  background-color: orange;
  width: 0.2in;
  height: 0.2in;
  border: 1px solid #e9ebf5;
}
.tiny_block_invert {
  background-color: white;
  width: 0.2in;
  height: 0.2in;
  border: 1px solid orange;
}
.tiny_block2 {
  background-color: rgb(255, 0, 179);
  width: 0.2in;
  height: 0.2in;
  border: 1px solid #e9ebf5;
}
.tiny_block2_invert {
  background-color: white;
  width: 0.2in;
  height: 0.2in;
  border: 1px solid rgb(255, 0, 179);
}
.tiny_num {
  width: 0.2in;
  min-width: 0.2in;
  height: 0.1in;
  font-family: "Courier New", Courier, monospace;
  font-size: 8px;
  font-weight: 600;
}
.tiny_num_invert {
  color: rgb(255, 51, 0);
}
@media print {
  /* styling goes here */
  .noprint {
    display: none;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "atkmtrx",
  mixins: [bus_common],
  data() {
    return {
      numbers: [],
      acanvas: {},
      atkmtx: {
        name: "Retif Cooper",
        attack_name: "Long Sword",
        stat_base: 14,
        bonus: 4,
        WC: 6,
        wc_bonus: 3,
        damavg: 12,
        dammax: 36,
      },
    };
  },
  computed: {
    thiscode() {
      return (
        this.getFirstThreeCharacters(this.atkmtx.name) +
        this.generateRandomFiveDigitNumber().toString()
      );
    },
    damage_array() {
      var arr_dam = [];
      arr_dam.push(Math.floor(this.atkmtx.damavg / 4));
      arr_dam.push(Math.floor(this.atkmtx.damavg / 2));
      arr_dam.push(Math.floor(this.atkmtx.damavg / 1.5));
      arr_dam.push(this.atkmtx.damavg);
      arr_dam.push(Math.floor(this.atkmtx.damavg * 1.5));
      var dam16 = Math.floor(this.atkmtx.damavg * 2);
      if (dam16 > this.atkmtx.dammax) {
        dam16 = this.atkmtx.dammax;
      }
      arr_dam.push(dam16);
      arr_dam.push(this.atkmtx.dammax);
      return arr_dam;
    },
    totalatk() {
      return parseInt(this.atkmtx.stat_base) + parseInt(this.atkmtx.bonus);
    },
    wc_count() {
      return parseInt(this.atkmtx.WC * 2) + parseInt(this.atkmtx.wc_bonus);
    },
  },
  methods: {
    getFirstThreeCharacters(str) {
      if (str.length < 3) {
        return str; // Return the string as is if it's less than 3 characters long
      }
      return str.substring(0, 3);
    },
    generateRandomFiveDigitNumber() {
      const min = 10000;
      const max = 99999;
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    async drawToCanvas(stream) {
      const canvas = document.createElement("canvas");
      const video = document.createElement("video");
      video.srcObject = stream;

      // Play it.
      await video.play();

      // Draw one video frame to canvas.
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext("2d").drawImage(video, 0, 0);

      return canvas;
    },
    async captrue() {
      var self = this;
      const mainContentArea = document.querySelector("#main-matrix");
      const cropTarget = await CropTarget.fromElement(mainContentArea);

      // Prompt user to share the tab's content.
      const stream = await navigator.mediaDevices.getDisplayMedia({
        preferCurrentTab: true,
      });
      const [track] = stream.getVideoTracks();

      // Start cropping the self-capture video track using the CropTarget <-- Magic!
      await track.cropTo(cropTarget);

      this.acanvas = await this.drawToCanvas(stream);
      // this.mrbreakpoint(this.acanvas);
      // this.acanvas.toBlob((blob) => {

      //   // See https://web.dev/patterns/files/save-a-file/ to save this blob locally.
      // });
      this.acanvas.toBlob(
        function (blob) {
          console.log(typeof blob); //let you have 'blob' here

          var blobUrl = URL.createObjectURL(blob);

          var link = document.createElement("a"); // Or maybe get it from the current document
          link.href = blobUrl;
          link.download =
            self.atkmtx.name + "_" + self.thiscode + "_atxmtx.png";
          link.innerHTML = "Click here to download the file";

          document.body.appendChild(link); // Or append it whereever you want
          document.querySelector("a").click(); //can add an id to be specific if multiple anchor tag, and use #id
        },
        "image/png",
        1
      ); // JPEG at 100% quality
    },

    message1() {
      alert("This button does nothing yet.");
    },
    init() {
      for (let index = 0; index < 50; index++) {
        this.numbers.push(index + 1);
      }
      this.$store.commit("setBrandbar_show", false);
      this.show_loader(false);
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
